module.exports = __webpack_public_path__ + "media/images/emblems/Grosswangen_LU-ca9261b9b48a4f549c4288b23197d2cb.png";